import { api, unwrapList } from '../../../shared/lib/axios';

export interface EvaluationPeriod {
  id: string;
  name: string;
  startsAt: string;
  endsAt: string;
}

export async function getActivePeriods(): Promise<EvaluationPeriod[]> {
  const { data } = await api.get<EvaluationPeriod[] | { data: EvaluationPeriod[] }>('/evaluation-periods/active');
  return unwrapList(data);
}
